import React, { FC } from 'react';

import { Box, Stack, Typography, useMediaSwitch, useMobile } from 'Modules/ui3';
import { fileUrl } from 'Modules/ui';

import Background from './assets/partnersBackground.png';
import { COMPANY_ICONS } from './companyIcons';


const PARTNERS_ORDER = ['MTS', 'OZON', 'WB', 'SFB', 'ALFA', 'ETALON', 'AFK', 'BINNOPHARM', 'SEGEZHA', 'SOVA', 'COSMOS'];

export const Partners: FC = () => {
    const isMobile = useMobile();
    return (
        <Stack
            spacing={isMobile ? 8 : 12}
            py={useMediaSwitch(22, 16, 8)}
            px={useMediaSwitch(12, 6, 2)}
            alignItems='center'
            bgcolor='#fff'
        >
            <Box
                width='100%'
                maxWidth='1200px'
                {...isMobile && {
                    px: 3,
                }}
            >
                <Typography
                    component='h1'
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('72px', '56px', '32px')}
                    fontWeight='700'
                    lineHeight={isMobile ? '1.25' : '1.3'}
                >
                    Наши партнеры
                </Typography>
            </Box>
            <Stack
                flexDirection={isMobile ? 'column' : 'row'}
                p={useMediaSwitch(12, 6, 2)}
                width='100%'
                maxWidth='1200px'
                justifyContent={isMobile ? 'flex-start' : 'flex-end'}
                height={isMobile ? '600px' : '680px'}
                borderRadius={useMediaSwitch(12, 10, 8)}
                overflow='hidden'
                sx={{
                    background: `url(${fileUrl(Background)}) ${useMediaSwitch(
                        '-164px -114.553px / 113.667% 133.692%',
                        '-483.621px -119.452px / 191.415% 135.133%',
                        '-546.546px -66.316px / 425.58% 176.874%',
                    )} no-repeat`,
                }}
            >
                <Stack
                    borderRadius={useMediaSwitch(8, 10, 6)}
                    overflow='hidden'
                    bgcolor='grayscale.shade0'
                    width={useMediaSwitch('480px', '448px', 'auto')}
                    p={isMobile ? 5 : 8}
                    {...isMobile ? {
                        spacing: 12,
                    } : {
                        justifyContent: 'space-between',
                    }}
                >
                    <Stack flexDirection='row' flexWrap='wrap' gap={2}>
                        {PARTNERS_ORDER.map(name => (
                            <Box
                                key={name}
                                borderRadius={6}
                                height={({ spacing }) => spacing(isMobile ? 14 : 16)}
                                width={({ spacing }) => spacing(isMobile ? 14 : 16)}
                                sx={{
                                    '>svg': {
                                        width: '100%',
                                        height: '100%',
                                    },
                                }}
                            >
                                {COMPANY_ICONS[name]}
                            </Box>
                        ))}
                    </Stack>
                    <Typography
                        variant={isMobile ? 'boldTitle5' : 'boldTitle4'}
                        color='#242424'
                        fontFamily='Hauora'
                        lineHeight={isMobile ? 1.2 : 1.25}
                    >
                        Выпускаем ЦФА крупных и средних российских компаний
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
